<template>
  <div>
    <autoLogout />
    <loader :loader="loader" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <MedicalRecordTable
            :getInfoOfPatient="getInfoOfPatient"
            @loaderTable="loaderTable"
          />
        </v-card-text>
      </v-card>
      <encabezado
        :elementos="titleDetails"
        :disabledButton="disabledHeader"
        v-if="showAction(2)"
      />
      <v-card v-if="showAction(2)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col v-if="viewClinicalEvent" cols="12" md="9" xl="10" sm="12">
              <v-autocomplete
                v-model="modelClinicalEvent"
                no-data-text="Sin resultados"
                :items="listClinicalEvent"
                @change="filterByClinicalEvent"
                label="Seleccionar evento clínico"
                clearable
                append-outer-icon="mdi-account-search"
              />
            </v-col>
            <v-col>
              <v-btn
                color="error"
                @click="downloadReport()"
                :disabled="loader || !modelClinicalEvent"
                block
              >
                Descargar ZIP <v-icon right> mdi-folder-zip </v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <div class="row">
            <v-col cols="12" sm="12" md="3" lg="3" xs="3">
              <div class="elevation-1" style="border: 0.5px solid white">
                <div class="container">
                  <div class="row">
                    <div class="col">
                      <div class="mb-3">
                        <p class="title text-center">
                          Información del paciente
                        </p>
                      </div>
                      <div
                        v-for="(data, index) in datosPersonales"
                        :key="index"
                      >
                        <div class="container">
                          <v-divider class="mb-5"></v-divider>
                          <v-row align="center">
                            <v-col align="center">
                              <v-avatar size="150" v-if="data.imagePatient">
                                <img
                                  v-if="data.imagePatient"
                                  :alt="data.fullName"
                                  :src="data.imagePatient"
                                />
                              </v-avatar>
                              <v-avatar
                                color="green darken-2"
                                size="150"
                                v-else
                              >
                                <v-icon dark size="150">
                                  mdi-account-circle
                                </v-icon>
                              </v-avatar>
                            </v-col>
                          </v-row>
                          <br />
                          <v-subheader
                            ><span class="headerInfo"
                              >Información personal</span
                            ></v-subheader
                          >
                          <v-divider class="mb-5"></v-divider>

                          <v-row align="center">
                            <v-col class="col-md-12">
                              <p class="">
                                <strong>Nombre: </strong>
                                <span class="">{{ data.fullName }}</span>
                              </p>
                              <p class="">
                                <strong>CURP: </strong>
                                <span class="">{{ data.curp }}</span>
                              </p>
                              <p class="">
                                <strong>Fecha de nacimiento: </strong>
                                <span class="">{{ data.birthDate }}</span>
                              </p>
                            </v-col>

                            <v-col>
                              <p class="">
                                <strong>Institución aseguradora: </strong>
                                <span class="">{{ data.healthInsurance }}</span>
                              </p>

                              <p
                                class=""
                                v-if="
                                  data.healthInsurance.toLowerCase() === 'imss'
                                "
                              >
                                <strong>NSS: </strong>
                                <span class="">{{ data.imssNumber }}</span>
                              </p>
                              <p
                                class=""
                                v-if="
                                  data.healthInsurance.toLowerCase() === 'imss'
                                "
                              >
                                <strong>Agregado médico: </strong>
                                <span class="">{{
                                  data.medicalAggregated
                                }}</span>
                              </p>
                              <p
                                class=""
                                v-if="
                                  data.healthInsurance.toLowerCase() !=
                                    'no aplica' &&
                                    data.healthInsurance.toLowerCase() != 'imss'
                                "
                              >
                                <strong>Número de afiliación: </strong>
                                <span class="">{{
                                  data.membershipNumber
                                }}</span>
                              </p>

                              <p
                                class=""
                                v-if="
                                  data.healthInsurance.toLowerCase() === 'imss'
                                "
                              >
                                <strong>IDEE: </strong>
                                <span class="">{{ data.idee }}</span>
                              </p>
                              <p class="">
                                <strong>Fecha de registro: </strong>
                                <span class="">{{
                                  data.registrationDate
                                }}</span>
                              </p>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-subheader
                                ><span class="headerInfo"
                                  >Información de contacto</span
                                ></v-subheader
                              >
                              <v-divider class="mb-5"></v-divider>
                              <p class="">
                                <strong>Dirección: </strong>
                                <span class="">{{ data.address }}</span>
                              </p>
                              <p class="">
                                <strong>Teléfono de casa: </strong>
                                <span class="">{{ data.homePhone }}</span>
                              </p>
                              <p class="">
                                <strong>Teléfono móvil: </strong>
                                <span class="">{{ data.phone }}</span>
                              </p>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="9" lg="9" xs="9">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-seat-flat </v-icon>
                      <span>Imagen: {{ 0 || listStudies.length }}</span>
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ImageAppointmentTable
                      :downloadInterpretationImage="downloadInterpretationImage"
                      :downloadZIP="downloadZIP"
                      :listStudies="listStudies"
                      :sending="sending"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-test-tube </v-icon>
                      Laboratorio: {{ 0 || listLaboratoryStudies.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <LaboratoryAppointmentTable
                      :downloadInterpretationLaboratory="
                        downloadInterpretationLaboratory
                      "
                      :listLaboratoryStudies="listLaboratoryStudies"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-tooth </v-icon>
                      Dental: {{ 0 || listDentalConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <DentalAppointmentTable
                      :downloadDentalConsultation="downloadDentalConsultation"
                      :listDentalConsultations="listDentalConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-stethoscope </v-icon>
                      Consultas: {{ 0 || listMedicalConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ConsultationAppointmentTable
                      :exportToPdf="exportToPdf"
                      :listMedicalConsultations="listMedicalConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- PSYCHOLOGY
                @MaudePallares
              suim 2.0 -->
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-brain </v-icon>
                      Psicología : {{ 0 || listPsychoConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <PsychologyApppointmentTable
                      :exportToPdf="exportToPdf"
                      :listPsychoConsultations="listPsychoConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-eye </v-icon>
                      Optometría : {{ 0 || listOptometryConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <OptometryApppointmentTable
                      :exportToPdf="exportToPdf"
                      :listOptometryConsultations="listOptometryConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-ear-hearing </v-icon>
                      Audiometría :
                      {{ 0 || listAudiometryConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <AudiometryApppointmentTable
                      :exportToPdf="exportToPdf"
                      :listAudiometryConsultations="listAudiometryConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- <v-expansion-panel v-if="$utilFront.SHOW_COLPOSCOPY">
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-crosshairs-gps </v-icon>
                      Colposcopia :
                      {{ 0 || listColposcopyConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ColposcopyApppointmentTable
                      :exportToPdf="exportToPdf"
                      :listColposcopyConsultations="listColposcopyConsultations"
                    />
                  </v-expansion-panel-content> 
                </v-expansion-panel> -->
                <v-expansion-panel v-if="$utilFront.SHOW_TELEMEDICINE">
                  <v-expansion-panel-header disable-icon-rotate>
                    <span>
                      <v-icon left color="grey"> mdi-monitor-dashboard </v-icon>
                      Telemedicina :
                      {{ 0 || listTelemedicineConsultations.length }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <TelemedicineAppointmentTable
                      :exportToPdf="exportToPdf"
                      :listTelemedicineConsultations="listTelemedicineConsultations"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </div>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-col>
            <v-btn color="error" plain @click="changeAction(1)">
              <v-icon left>mdi-chevron-left</v-icon> Volver
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import {
  PatientRequest,
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
import router from "@/router";
import Datatable from "@/components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import HistorialPaciente from "@/components/HistorialPaciente";
import moment from "moment";
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import AutoLogout from "@/components/AutoLogout.vue";
import MedicalRecordTable from "@/views/MedicalRecord/MedicalRecordTable.vue";
import AppointmentTable from "@/views/MedicalRecord/appointmentTables/AppointmentTable.vue";
import ConsultationAppointmentTable from "@/views/MedicalRecord/appointmentTables/ConsultationAppointmentTable.vue";
import DentalAppointmentTable from "@/views/MedicalRecord/appointmentTables/DentalAppointmentTable.vue";
import ImageAppointmentTable from "@/views/MedicalRecord/appointmentTables/ImageAppointmentTable.vue";
import LaboratoryAppointmentTable from "@/views/MedicalRecord/appointmentTables/LaboratoryAppointmentTable.vue";
import PsychologyApppointmentTable from "@/views/MedicalRecord/appointmentTables/PsychologyApppointmentTable.vue";
import OptometryApppointmentTable from "@/views/MedicalRecord/appointmentTables/OptometryApppointmentTable.vue";
import AudiometryApppointmentTable from "@/views/MedicalRecord/appointmentTables/AudiometryApppointmentTable.vue";
//import ColposcopyApppointmentTable from "@/views/MedicalRecord/appointmentTables/ColposcopyApppointmentTable.vue";
import TelemedicineAppointmentTable from "@/views/MedicalRecord/appointmentTables/TelemedicineAppointmentTable.vue";


export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    HistorialPaciente,
    HistorialPaciente,
    Loader,
    AutoLogout,
    MedicalRecordTable,
    AppointmentTable,
    ConsultationAppointmentTable,
    DentalAppointmentTable,
    ImageAppointmentTable,
    LaboratoryAppointmentTable,
    PsychologyApppointmentTable,
    OptometryApppointmentTable,
    AudiometryApppointmentTable,
    //ColposcopyApppointmentTable,
    TelemedicineAppointmentTable
  },
  data: () => ({
    action: 1,
    loader: true,
    encabezado: { icono: "mdi-folder", texto: "Historia clínica" },
    dialogView: false,
    datosPaciente: {},
    ventana: "",
    disabledHeader: true,
    titleDetails: { icono: "mdi-clipboard-text", texto: "Expediente clínico" },
    searchPharmacy: "",
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
      "red",
    ],
    datosPaciente: [],
    datosPersonales: [],
    appointment: [],
    listStudies: [],
    listLaboratoryStudies: [],
    listMedicalConsultations: [],
    listPsychoConsultations: [],
    listOptometryConsultations: [],
    listAudiometryConsultations: [], 
    //listColposcopyConsultations: [],
    listTelemedicineConsultations: [],
    listDentalConsultations: [],
    listPharmacy: [],
    appointmentFull: [],
    listStudiesFull: [],
    listLaboratoryStudiesFull: [],
    listMedicalConsultationsFull: [],
    listTelemedicineConsultationsFull: [],
    listDentalConsultationsFull: [],
    listPsychoConsultationsFull: [],
    //listColposcopyConsultationsFull: [],
    listPharmacyFull: [],
    index: 1,
    sending: false,
    viewClinicalEvent: true,
    listClinicalEvent: [],
    listClinicalEventAll: [],
    modelClinicalEvent: "",
    eventTypeReason: "",
    itemClinicalEvent: [],
    createPDF: false,
    noDataOfClinicalEvent: false,
    /**
     * @MaudePallares
     */
    headersPharmacy: [
      { text: "#", value: "count" },
      { text: "ID receta", value: "registrationDate" },
      { text: "Clave", value: "specialty" },
      { text: "Dispensador", value: "doctorName" },
      { text: "Emitió receta", value: "appointmentDate" },
      { text: "Surtida", value: "actions" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
  }),
  mounted() {
    this.validBrowserTab();
  },
  methods: {
    changeAction(action) {
      if (action === 1) {
        this.action = action;
        this.appointment = [];
        this.listStudies = [];
        this.listLaboratoryStudies = [];
        this.listDentalConsultations = [];
        this.listMedicalConsultations = [];
        this.listPsychoConsultations = []; //MaudePallares
        this.listOptometryConsultations = []; //MaudePallares
        this.listAudiometryConsultations = []; //MaudePallares
        //this.listColposcopyConsultations = [];
        this.listTelemedicineConsultations = []; 
      } else if (2) {
        this.loader = false;
        this.action = action;
      }
    },
    showAction(action) {
      return this.action == action;
    },

    ...mapActions(["validTab", "logout", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },

    showModal() {
      this.dialogView = true;
    },
    loaderTable(load) {
      this.loader = load;
    },
    getInfoOfPatient(idPatient) {
      // let id = localStorage.getItem("idPaciente");
      if (!this.loader) {
        this.loader = true;
        let id = idPatient;

        let postData = {
          idPatient: id,
        };

        this.appointment = [];
        this.listStudies = [];
        this.listLaboratoryStudies = [];
        this.listMedicalConsultations = [];
        this.listDentalConsultations = [];
        this.listPsychoConsultations = [];
        this.listOptometryConsultations = [];
        this.listAudiometryConsultations = [];
        //this.listColposcopyConsultations = [];
        this.listTelemedicineConsultations = []; 
        PatientRequest.getPatientInfoClinicHistory(postData)
          .then((res) => {
            let objData = [];

            objData.push(res.data.data.patient);
            this.datosPersonales = objData.map((data) => {
              if (data.imssNumber == null || data.imssNumber === "") {
                data.imssNumber = "N/D";
              }
              if (data.idee == null || data.idee === "") {
                data.idee = "N/D";
              }
              data.phone = !this.$utilFront.isEmpty(data.phone)
                ? data.phone
                : "N/D";
              data.homePhone = !this.$utilFront.isEmpty(data.homePhone)
                ? data.homePhone
                : "N/D";
              data.membershipNumber = !this.$utilFront.isEmpty(
                data.membershipNumber
              )
                ? data.membershipNumber
                : "N/D";
              return data;
            });
            if (res.data.code === 200 && res.data.status === "OK") {
              this.datosPaciente = res.data.data;
              this.listClinicalEventAll = this.datosPaciente.clinicalEventList;
              this.listClinicalEvent = this.datosPaciente.clinicalEventList.map(
                (e) => {
                  let text =
                    this.$utilFront.formatDate(e.registrationDate) +
                    " | " +
                    e.eventType +
                    " | " +
                    e.idClinicalEvent;
                  return {
                    text: text,
                    value: e.idClinicalEvent,
                  };
                }
              );
              this.datosPaciente.clinicalEventList.map((e) => {
                e.medicalAppointments.map((app) => {
                  app.registrationDate = this.dateFormat(
                    app.registrationDate,
                    false
                  );
                  app.appointmentDate = this.dateFormat(
                    app.appointmentDate,
                    true
                  );
                  if (
                    this.appointment.find(
                      (element) => element.idAppointment == app.idAppointment
                    ) == undefined
                  ) {
                    this.appointment.push(app);
                  }
                });

                e.studies.map((study) => {
                  study.registrationDate = this.dateFormat(
                    study.registrationDate,
                    true
                  );
                  study.interpretationDate = this.dateFormat(
                    study.interpretationDate,
                    true
                  );
                  study.accessionNumber = study.accessionNumber
                    ? study.accessionNumber
                    : "ND";
                  if (
                    this.listStudies.find(
                      (element) => element.idStudy == study.idStudy
                    ) == undefined
                  ) {
                    this.listStudies.push(study);
                  }
                });

                e.laboratoryStudies.map((study) => {
                  study.registrationDate = this.dateFormat(
                    study.registrationDate,
                    true
                  );
                  study.interpretationDate = this.dateFormat(
                    study.interpretationDate,
                    true
                  );
                  if (
                    this.listLaboratoryStudies.find(
                      (element) => element.idStudy == study.idStudy
                    ) == undefined
                  ) {
                    this.listLaboratoryStudies.push(study);
                  }
                });

                e.medicalConsultations.map((medical) => {
                  medical.registrationDate = this.dateFormat(
                    medical.registrationDate,
                    true
                  );
                  let text = medical.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  medical.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (medical.diagnostic1 = text)
                    : (medical.diagnostic1 = text.substring(0, 900) + "...");
                  medical.consultationDate = this.dateFormat(
                    medical.consultationDate,
                    true
                  );
                  if (
                    this.listMedicalConsultations.find(
                      (element) =>
                        element.idMedicalPractice == medical.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listMedicalConsultations.push(medical);
                  }
                });

                e.dentalConsultations.map((dental) => {
                  dental.registrationDate = this.dateFormat(
                    dental.registrationDate,
                    true
                  );
                  let text = dental.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  dental.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (dental.diagnostic1 = text)
                    : (dental.diagnostic1 = text.substring(0, 900) + "...");
                  dental.consultationDate = this.dateFormat(
                    dental.consultationDate,
                    true
                  );
                  if (
                    this.listDentalConsultations.find(
                      (element) =>
                        element.idMedicalPractice == dental.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listDentalConsultations.push(dental);
                  }
                });

                /**
                 * @MaudePallares
                 * Psychology
                 * Erillam Healthcare
                 * Suim 2.0
                 */
                e.psychologyConsultations.map((psycho) => {
                  psycho.registrationDate = this.dateFormat(
                    psycho.registrationDate,
                    true
                  );
                  let text = psycho.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  psycho.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (psycho.diagnostic1 = text)
                    : (psycho.diagnostic1 = text.substring(0, 900) + "...");
                  psycho.consultationDate = this.dateFormat(
                    psycho.consultationDate,
                    true
                  );
                  if (
                    this.listPsychoConsultations.find(
                      (element) =>
                        element.idMedicalPractice == psycho.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listPsychoConsultations.push(psycho);
                  }
                });
                e.optometryConsultations.map((opto) => {
                  opto.registrationDate = this.dateFormat(
                    opto.registrationDate,
                    true
                  );
                  let text = opto.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  opto.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (opto.diagnostic1 = text)
                    : (opto.diagnostic1 = text.substring(0, 900) + "...");
                  opto.consultationDate = this.dateFormat(
                    opto.consultationDate,
                    true
                  );
                  if (
                    this.listOptometryConsultations.find(
                      (element) =>
                        element.idMedicalPractice == opto.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listOptometryConsultations.push(opto);
                  }
                });

                e.audiometryConsultations.map((audio) => {
                  audio.registrationDate = this.dateFormat(
                    audio.registrationDate,
                    true
                  );
                  let text = audio.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  audio.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (audio.diagnostic1 = text)
                    : (audio.diagnostic1 = text.substring(0, 900) + "...");
                  audio.consultationDate = this.dateFormat(
                    audio.consultationDate,
                    true
                  );
                  if (
                    this.listAudiometryConsultations.find(
                      (element) =>
                        element.idMedicalPractice == audio.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listAudiometryConsultations.push(audio); 
                  }
                });

                /* e.colposcopyConsultations.map((audio) => {
                  audio.registrationDate = this.dateFormat(
                    audio.registrationDate,
                    true
                  );
                  let text = audio.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  audio.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (audio.diagnostic1 = text)
                    : (audio.diagnostic1 = text.substring(0, 900) + "...");
                  audio.consultationDate = this.dateFormat(
                    audio.consultationDate,
                    true
                  );
                  if (
                    this.listColposcopyConsultations.find(
                      (element) =>
                        element.idMedicalPractice == audio.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listColposcopyConsultations.push(audio);
                  }
                }); */

                e.telemedicineConsultations.map((tele) => {
                  tele.registrationDate = this.dateFormat(
                    tele.registrationDate,
                    true
                  );
                  let text = tele.diagnostic.replace(/(<([^>]+)>)/gi, " ");
                  tele.diagnostic =
                    text.length < 35 ? text : text.substring(0, 35) + "...";
                  text.length < 900
                    ? (tele.diagnostic1 = text)
                    : (tele.diagnostic1 = text.substring(0, 900) + "...");
                  tele.consultationDate = this.dateFormat(
                    tele.consultationDate,
                    true
                  );
                  if (
                    this.listTelemedicineConsultations.find(
                      (element) =>
                        element.idMedicalPractice == tele.idMedicalPractice
                    ) == undefined
                  ) {
                    this.listTelemedicineConsultations.push(tele);
                  }
                });

              });
              this.appointmentFull = this.appointment;
              this.listStudiesFull = this.listStudies;
              this.listLaboratoryStudiesFull = this.listLaboratoryStudies;
              this.listMedicalConsultationsFull = this.listMedicalConsultations;
              this.listDentalConsultationsFull = this.listDentalConsultations;
              this.listPsychoConsultationsFull = this.listPsychoConsultations; 
              //this.listColposcopyConsultationsFull = this.listColposcopyConsultations;
              this.listTelemedicineConsultationsFull = this.listTelemedicineConsultations;

              res.data.data.patient.registrationDate = this.dateFormat(
                res.data.data.patient.registrationDate,
                true
              );
              res.data.data.patient.birthDate = this.dateFormat(
                res.data.data.patient.birthDate,
                false
              );
              this.changeAction(2);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Error al consultar, intente nuevamente",
                "ERROR"
              );
            }
          })
          .catch((e) => console.log(e))
          .finally(() => {
            this.loader = false;
          });
      }
    },
    dateFormat(date, flag) {
      let dateFormat;
      if (flag) {
        dateFormat =
          date != null
            ? moment(new Date(date)).format("DD/MM/YYYY HH:mm")
            : "- - -";
      } else {
        dateFormat =
          date != null ? moment(new Date(date)).format("DD/MM/YYYY") : "--";
      }
      return dateFormat;
    },
    downloadInterpretationLaboratory(interpretation) {
      this.loader = true;
      let data = {
        idStudy: interpretation.idStudy,
        interpretationText: "",
        fileName: "Estudio de laboratorio",
      };
      ReportPDFRequest.downloadInterpretationByID(data);
      this.loader = false;
    },

    async downloadInterpretationImage(item, type = 0) {
  this.loader = true;
  try {
    const modality = (item.modality || '').toUpperCase();

    // Construir el nombre base para todos los archivos
    let filename = '';
    let displayName = '';
    
    if (this.datosPersonales[0]?.fullName && this.datosPersonales[0]?.idPatient) {
      const nameParts = this.datosPersonales[0].fullName.trim().split(/\s+/).filter(part => part !== '');
      const numParts = nameParts.length;
      
      if (numParts === 1) {
        filename = `${nameParts[0]} - ${this.datosPersonales[0].idPatient}`;
        displayName = `${nameParts[0]} - ${this.datosPersonales[0].idPatient}`;
      } else {
        let apellidosCount;
        
        if (numParts === 2) {
          apellidosCount = 1;
        } else if (numParts === 3) {
          apellidosCount = 2;
        } else if (numParts === 4) {
          apellidosCount = 2;
        } else {
          apellidosCount = 2;
        }
        
        const apellidos = nameParts.slice(-apellidosCount).join('');
        const nombres = nameParts.slice(0, -apellidosCount).join('');
        
        filename = `${apellidos}${nombres} - ${this.datosPersonales[0].idPatient}`;
        displayName = `${apellidos}${nombres} - ${this.datosPersonales[0].idPatient}`;
      }
    } else {
      filename = `Interpretacion-${item.idStudy}`;
      displayName = `Interpretacion-${item.idStudy}`;
    }

    // Agregar sufijos según el tipo y modalidad
    if (modality === 'PAPANICOLAOU') {
      if (type === 0 || type === 1) {
        const suffix = type === 0 ? '_EntregablePaciente' : '_InformeMedico';
        filename += `${suffix}.pdf`;
        
        await StudyRequest.papanicolaouDowloadReport({
          idStudy: item.idStudy,
          type, 
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        });
      
      } else if (type === 2) {
        filename += '_Resultados.pdf';
        
        const response = await StudyRequest.papanicolaouViewReport({
          idStudy: item.idStudy,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        });
        
        const file = response.data.studyFiles?.[0];
        if (file?.bytes) {
          const binary = atob(file.bytes);
          const arr = Uint8Array.from(binary, c => c.charCodeAt(0));
          const blob = new Blob([arr], { type: 'application/pdf' });
          const pdfUrl = URL.createObjectURL(blob);

          // Crear página HTML para abrir en nueva pestaña con nombre personalizado
          const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName} - Resultados</title>
    <style>
        body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
        embed { width: 100%; height: 100%; border: none; }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

          const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
          const htmlUrl = URL.createObjectURL(htmlBlob);
          window.open(htmlUrl, '_blank');

          // También ofrecer descarga
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => {
            URL.revokeObjectURL(pdfUrl);
            URL.revokeObjectURL(htmlUrl);
          }, 60000);
        } else {
          this.$utilFront.notifications('No se encontró el archivo PDF', 'WARNING');
        }
      }
    
    } else {
      // Para otras modalidades
      filename += '.pdf';
      
      const response = await ReportPDFRequest.downloadInterpretation1({
        idInterpretation: item.idInterpretation,
        interpretationText: '',
        fileName: filename,
        type,
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Crear página HTML para abrir en nueva pestaña con nombre personalizado
      const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName}</title>
    <style>
        body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
        embed { width: 100%; height: 100%; border: none; }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const htmlUrl = URL.createObjectURL(htmlBlob);
      window.open(htmlUrl, '_blank');

      // También ofrecer descarga
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
        URL.revokeObjectURL(htmlUrl);
      }, 60000);
    }

  } catch (e) {
    console.error(e);
    this.$utilFront.notifications('Error al descargar el archivo', 'ERROR');
  } finally {
    this.loader = false;
  }
},
    downloadConsultation(consultation) {
      this.loader = true;
      let data = {
        idConsultation: consultation.idMedicalPractice,
        idDiagnostic: consultation.idDiagnostic,
        fileName: "Consulta",
      };
      ReportPDFRequest.downloadConsultation(data);
      this.loader = false;
    },
   downloadZIP(item) {
  this.loader = true;
  try {
    this.sending = true;
    let data = { idStudy: item.idStudy };
    DownloadZipRequest.downloadImagesDCM(data)
      .then((res) => {
        // Construir el nombre del archivo con el formato: ApellidosNombres - ID.zip
        let filename = '';
        
        if (this.datosPersonales[0]?.fullName && this.datosPersonales[0]?.idPatient) {
          const nameParts = this.datosPersonales[0].fullName.trim().split(/\s+/).filter(part => part !== '');
          const numParts = nameParts.length;
          
          if (numParts === 1) {
            filename = `${nameParts[0]} - ${this.datosPersonales[0].idPatient}.zip`;
          } else {
            let apellidosCount;
            
            if (numParts === 2) {
              apellidosCount = 1;
            } else if (numParts === 3) {
              apellidosCount = 2;
            } else if (numParts === 4) {
              apellidosCount = 2;
            } else {
              apellidosCount = 2;
            }
            
            const apellidos = nameParts.slice(-apellidosCount).join('');
            const nombres = nameParts.slice(0, -apellidosCount).join('');
            
            filename = `${apellidos}${nombres} - ${this.datosPersonales[0].idPatient}.zip`;
          }
        } else {
          filename = `Estudio-${item.idStudy}.zip`;
        }

        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/zip",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        
        // Liberar memoria después de un tiempo
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 60000);
      })
      .catch(this.catchError)
      .finally(() => {
        this.sending = false;
        this.loader = false;
      });
  } catch (e) {
    this.catchError(e);
  }
},
    catchError(e) {
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },
    filterByClinicalEvent() {
      try {
        if (
          this.modelClinicalEvent != null &&
          this.modelClinicalEvent != undefined &&
          this.modelClinicalEvent != ""
        ) {
          this.createPDF = true;
          this.itemClinicalEvent = this.listClinicalEventAll.filter((e) => {
            return e.idClinicalEvent == this.modelClinicalEvent;
          });
          this.noDataOfClinicalEvent = true;

          this.eventTypeReason = this.itemClinicalEvent[0].reason;
          this.appointment = this.itemClinicalEvent[0].medicalAppointments;
          this.listStudies = this.itemClinicalEvent[0].studies.map(
            (element) => {
              if (element.status == 6 || element.status == 7) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listLaboratoryStudies = this.itemClinicalEvent[0].laboratoryStudies.map(
            (element) => {
              if (element.status == 13) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listMedicalConsultations = this.itemClinicalEvent[0].medicalConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listDentalConsultations = this.itemClinicalEvent[0].dentalConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listPsychoConsultations = this.itemClinicalEvent[0].psychologyConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listOptometryConsultations = this.itemClinicalEvent[0].optometryConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
          this.listAudiometryConsultations = this.itemClinicalEvent[0].audiometryConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            } 
          );
          /* this.listColposcopyConsultations = this.itemClinicalEvent[0].colposcopyConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          ); */

          this.listTelemedicineConsultations = this.itemClinicalEvent[0].telemedicineConsultations.map(
            (element) => {
              if (element.status == 3 || element.status == 4) {
                this.noDataOfClinicalEvent = true;
              }
              return element;
            }
          );
        } else {
          this.resetAllList();
        }
      } catch (error) {
        this.resetAllList();
        this.catchError(error);
      }
    },
    resetAllList() {
      this.createPDF = false;
      this.eventTypeReason = "";
      this.appointment = this.appointmentFull;
      this.listStudies = this.listStudiesFull;
      this.listLaboratoryStudies = this.listLaboratoryStudiesFull;
      this.listMedicalConsultations = this.listMedicalConsultationsFull;
      this.listDentalConsultations = this.listDentalConsultationsFull;
      //this.listColposcopyConsultations = this.listColposcopyConsultationsFull;
      this.listTelemedicineConsultations = this.listTelemedicineConsultationsFull;
    },
    downloadReport() {
      this.itemClinicalEvent = this.listClinicalEventAll.find((e) => {
        return e.idClinicalEvent == this.modelClinicalEvent;
      });
      this.noDataOfClinicalEvent = false;
      this.loader = true;
      
      // Construir el nombre del archivo con el formato: ApellidoPaternoApellidoMaternoNombres - IDPatient.zip
      let filename = '';
      
      if (this.datosPersonales[0]?.fullName && this.datosPersonales[0]?.idPatient) {
        const nameParts = this.datosPersonales[0].fullName.trim().split(/\s+/).filter(part => part !== '');
        const numParts = nameParts.length;
        
        if (numParts === 1) {
          filename = `${nameParts[0]} - ${this.datosPersonales[0].idPatient}.zip`;
        } else if (numParts === 2) {
          // Un nombre y un apellido: "Juan Pérez"
          const apellidoPaterno = nameParts[1];
          const nombres = nameParts[0];
          filename = `${apellidoPaterno}${nombres} - ${this.datosPersonales[0].idPatient}.zip`;
        } else {
          // 3 o más partes: determinar apellidos
          let apellidosCount;
          
          if (numParts === 3) {
            // Ejemplo: "María García López" -> 1 nombre, 2 apellidos
            apellidosCount = 2;
          } else if (numParts === 4) {
            // Ejemplo: "José Luis Hernández García" -> 2 nombres, 2 apellidos
            apellidosCount = 2;
          } else {
            // Para 5+ partes: 2 apellidos, el resto nombres
            apellidosCount = 2;
          }
          
          // Los últimos elementos son los apellidos (primero el paterno, luego el materno)
          const apellidos = nameParts.slice(-apellidosCount);
          // El resto son nombres
          const nombres = nameParts.slice(0, -apellidosCount).join('');
          
          // Orden correcto: apellido paterno + apellido materno + nombres
          const apellidoPaterno = apellidos[0];
          const apellidoMaterno = apellidos[1] || '';
          const apellidosCompletos = apellidoPaterno + apellidoMaterno;
          
          filename = `${apellidosCompletos}${nombres} - ${this.datosPersonales[0].idPatient}.zip`;
        }
      } else {
        filename = `Reporte_historia_clinica.zip`;
      }

      let data = {
        idPatient: this.datosPersonales[0].idPatient,
        idClinicalEvent: this.itemClinicalEvent.idClinicalEvent,
        fileName: "Reporte historia clinica",
      };
      
      ReportPDFRequest.downloadClinicalEvent(data)
        .then((res) => {
          this.$utilFront.downloadZIP(res.data, filename);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    downloadDentalConsultation(consultation) {
      this.loader = true;
      let data = {
        idConsultation: consultation.idMedicalPractice,
        idDiagnostic: consultation.idDiagnostic,
        fileName: "Consulta",
      };
      ReportPDFRequest.downloadDentalReport(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    exportToPdf(consultation) {
      this.loader = true;
      const fileName = `Consulta_${consultation.idMedicalPractice}_${moment(
        new Date(consultation.consultationDate)
      ).format("YYYY-MM-DD")}`;
      let data = {
        idConsultation: consultation.idMedicalPractice,
        idDiagnostic: consultation.idDiagnostic,
        fileName: fileName,
      };
      ReportPDFRequest.downloadConsultation1(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
  },
};
</script>
